/**
 * iosDetect.js — minimal, dependency-free iOS Safari detection.
 *
 * Used by the upload pipeline to force conservative concurrency
 * (parallelChunks = 1, sequential row uploads) on devices that are
 * memory-constrained and prone to WKWebView eviction during
 * concurrent file uploads.
 *
 * Doctrine: this file does ONE thing. It does not classify
 * browsers beyond "is this iOS Safari / iPadOS Safari". If a more
 * sophisticated capability detection becomes necessary later, add
 * a separate module — do not extend this one.
 */

/**
 * Returns true on iPhone, iPad, iPod Touch, AND iPad-in-desktop-mode
 * (which iOS 13+ reports as Macintosh with maxTouchPoints > 1).
 */
export function isIOSSafari() {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  // Genuine mobile UA path
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  // iPadOS 13+ requesting desktop site — UA says Macintosh, but
  // there's a touch screen. The platform is iOS regardless of the
  // UA disguise.
  if (/Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1) return true;
  return false;
}
